import { Package } from "lucide-react";
import { productImageUrl } from "@/lib/api";

// Uniform 1:1 product image frame: full image visible, centered, never cropped or stretched.
export default function ProductImage({ path, alt = "", size = "sm", className = "", pad = "p-[8%]", iconClass = "h-5 w-5", testId, bg = "bg-white", blend = false }) {
  return (
    <span
      data-testid={testId}
      className={`relative block aspect-square shrink-0 overflow-hidden ${bg} ${className}`}
    >
      {path ? (
        <img
          src={productImageUrl(path, size, true)}
          alt={alt}
          loading="lazy"
          decoding="async"
          draggable={false}
          className={`absolute inset-0 h-full w-full object-contain object-center ${blend ? "mix-blend-multiply" : ""} ${pad}`}
        />
      ) : (
        <span className="absolute inset-0 grid place-items-center text-blue-200">
          <Package className={iconClass} />
        </span>
      )}
    </span>
  );
}
